/**
 * The Compliance screen's two columns: "How long things are kept" on the left, the stacked side
 * cards (Do not call, Requests about one person, Outbound caller ID) on the right.
 *
 * Its own component so the layout rule lives in one place: the columns sit side by side while
 * each can have its full panel width, and stack into one full-width column when they cannot —
 * never wider than the space the page has, so a narrow window (a phone) scrolls down, not
 * sideways (customer-portal review item 206). The shell around the page is not this component's.
 */
import type { ReactNode } from "react";

export function ComplianceColumns({
  main,
  side,
}: {
  readonly main: ReactNode;
  readonly side: ReactNode;
}): ReactNode {
  return (
    <div className="cmp-columns">
      {main}
      <div className="cmp-side">{side}</div>
    </div>
  );
}
